import React,{ useState, useEffect, useRef } from "react";
import { 
    Button,
    Form,
    Input,
} from 'antd';

import axios from 'axios';
import CountdownTimer from './CountdownTimer';

import { 
    MinusCircleOutlined
} from '@ant-design/icons';

function QualificationForm( { 
    isFibreComponent, 
    hasFibreServices,
    handleModalCancel,
    doAutoFocus,
    koodoRedirectLoading,
    setKoodoRedirectLoading,
    modalOpen,
    standalonePhonePurchaseAttempt,
    standaloneTVPurchaseAttempt,
    } ) {

    const [addressSuggestionList, setAddressSuggestionList] = useState(<></>);
    const [qualificationAddress, setQualificationAddress] = useState(null);
    const [qualificationAddressUnit, setQualificationAddressUnit] = useState('');
    const [addressesQualifying, setAddressQualifying] = useState( false );
    const [addressDetails, setAddressDetails] = useState( null );
    const [qualificationHeader, setQualificationHeader] = useState( '' );
    const [showQualificationForm, setShowQualificationForm] = useState( true );
    const [qualificationCopy, setQualificationCopy] = useState( '' );
    const [magicKey, setMagicKey] = useState( '' );
    const [countdownTimer, setCountdownTimer] = useState(<></>);
    //const [cancelRedirect, setCancelRedirect] = useState( false );
    const [form] = Form.useForm();
    const siteDomain = headerVars.siteDomain;
    const addressInput = useRef( null );

    let cancelRedirect = false;

    

    useEffect(() => {
        //console.log('isFibreComponent: ', isFibreComponent);
        //console.log('hasFibreServices: ', hasFibreServices);
        //console.log('doAutoFocus: ', doAutoFocus);
        //console.log('koodoRedirectLoading: ', koodoRedirectLoading);
        if( doAutoFocus ){ addressInput.current.focus() }

        if( !koodoRedirectLoading ) {
            if( isFibreComponent && !hasFibreServices ) {
                setQualificationHeader(<h2>Check availability of Fibre Internet plans</h2>);
                setQualificationCopy(  <p>Enter your address to find out what’s available in your area.</p> );
            } else if( isFibreComponent && hasFibreServices ){
                setQualificationHeader(<h2>Awesome! Fibre is available at your address.</h2>);
                setQualificationCopy(<p>What are you waiting for? You’re just a few steps away from getting your fibre connection, so buckle up,<br/>and get ready for some seriously fast internet.</p>);
            } else {
                setQualificationHeader(<h2>Check availability of Internet plans</h2>);
                setQualificationCopy(  <p>Enter your address to find out what’s available in your area.</p> );
            }
        } else {
            setQualificationCopy(
                <>
                    <p>Start.ca and Koodo are now one — enjoy expanded service offerings and support.</p>
                    <Button 
                        type="primary"
                        className="standalone-address-qualifier-btn goto-koodo-btn"
                        loading={ koodoRedirectLoading }
                        style={ 
                            { 
                                backgroundColor:'#1C4A12', 
                                paddingTop:'2px', 
                                paddingBottom:'2px', 
                                marginBottom:'0px',
                                paddingRight:'2rem',
                                paddingLeft:'2rem',
                                fontWeight:'600'
                            }
                         }
                        onClick={ (e) => handleRedirectToKoodo( e, serviceObj ) }>
                        Continue To Koodo
                    </Button>
                    <Button 
                        className="no-koodo-redirect"
                        style={ 
                            { 
                                backgroundColor:'#fff', 
                                paddingTop:'2px', 
                                paddingBottom:'2px', 
                                marginBottom:'0px',
                                paddingRight:'2rem',
                                paddingLeft:'2rem',
                                marginLeft:'0.5rem',
                                fontWeight:'600'
                            }
                         }
                        onClick={ handleDontRedirect }>
                        Stay On This Page
                    </Button>
                    <p style={{fontSize:'0.8rem', marginTop:'1rem'}}>Want to know about the benefits of Start.ca’s partnership with Koodo? <a className='koodo-redirect-modal-learn-more-link' href="/about-us/telus-partnership">Learn more</a>.</p>
                </>
            );
        }

        
    },[ hasFibreServices, doAutoFocus, koodoRedirectLoading ]);

    const handleOnInputChange = ( e ) => {
        let currentVal = e.target.value;
        let inputID = e.target.id;
        let form_data = new FormData;
        form_data.append('headers', {"Authorization": "Bearer "+headerVars.startAPIKey});

        if( currentVal.length > 6 ) {
            axios
            .get(headerVars.startAPIAddress+"/address/validate_telus?fullAddress="+currentVal, {headers:{"Authorization": "Bearer "+headerVars.startAPIKey}})
            .then(function(response){
                let suggestions = response.data.body.suggestions;
                let source = response.data.body.source;
                //console.log('suggestions: ', suggestions);

                if(suggestions.length){
                    listAddressSugestions(source, suggestions, 'qualification'); 
                }
            })
            .catch(function (error) {
                //console.log(error);
            })
            .finally(function () {
                // always executed 
            }); 
        }
    }

    const listAddressSugestions = ( source, suggestions, lookupType ) => {
        let suggestionListItems = suggestions.map( suggestion => {
            let suggestionText = suggestion.text.replace(', CAN', '');
            return(
                <li id={suggestion.magicKey} className='address-suggestion-item' onClick={( e ) => handleSuggestionClick( e, source, suggestionText, lookupType ) }>
                    { suggestionText + ". " }
                </li>
            );
        } );

        setAddressSuggestionList( <ul>{ suggestionListItems }</ul> );
    }

    const handleSuggestionClick = ( e, source, suggestionText, lookupType ) => {
        //console.log("suggestionText:: ", suggestionText);
        setAddressSuggestionList(<></>);
        setMagicKey( e.target.id );
        form.setFieldsValue({ "qualification-address": suggestionText});

        getAddressDetails( e.target.id, suggestionText, source );
    }

    const handleOnAddressUnitChange = ( e ) =>{
        let currentVal = e.target.value;
        let inputID = e.target.id;

        setQualificationAddressUnit( currentVal );
    }

    function getAddressDetails( selectedID, addressInput, source ) {
        //console.log("selectedID:: ", selectedID);
        //console.log("addressInput:: ", addressInput);
        //console.log("source:: ", source);

        if( selectedID != '' ) {
            let form_data = new FormData;
            form_data.append('headers', {"Authorization": "Bearer "+headerVars.startAPIKey});

            axios
            .get(headerVars.startAPIAddress+"/address/details_telus?magicKey="+selectedID+"&text="+addressInput+"&source="+source, {headers:{"Authorization": "Bearer "+headerVars.startAPIKey}})
            .then(function(response){
                setQualificationAddress( addressInput );
                if(response.data.body.candidates.length){ 
                    //getAvailableServices(response.body.candidates); 
                    //qualifyAddressButton.removeClass('disabled');
                    //console.log("address details response:: ", response.data.body.candidates);
                    setAddressDetails( response.data.body.candidates );

                    //jQuery("#check-availability-modal-address-input").val(addressDetails[0].attributes.Match_addr);

                }
            })
            .catch(function (error) {
                console.log(error);
            })
            .finally(function () {
                // always executed 
            }); 
        }
    }

    const handleDontRedirect = () => {
        if( modalOpen ) { handleModalCancel(); }
        setCountdownTimer(<></>);
        setQualificationHeader(<h2>Check availability of Internet plans</h2>);
        setQualificationCopy(  <p>Enter your address to find out what’s available in your area.</p> );
        setShowQualificationForm( true );
        cancelRedirect = true;
    }

    const handleRedirectToKoodo = ( e, serviceObj ) =>{
        setKoodoRedirectLoading( true );
        window.location.href = 'https://www.koodomobile.com/on/shop/subscriptions/internet?cmp=prt_kd_sod_tar_ah_starttoki&lpdsid='+magicKey;
    }

    const handleConfirmChangeQualificationAddress = () =>{
        setAddressQualifying( true );

        if( isFibreComponent ) {
            setQualificationHeader(<h2>Check availability of Fibre Internet plans</h2>);
            setQualificationCopy(  <p>Enter your address to find out what’s available in your area.</p> );
        } else {
            setQualificationHeader(<h2>Check availability of Internet plans</h2>);
            setQualificationCopy(  <p>Enter your address to find out what’s available in your area.</p> );
        }

        //console.log("addressDetails:: ",addressDetails );

        var postal1 = '';
        var postal2 = '';
        var strName = '';
        var strNumber = '';
        var strType = '';
        var strDir = '';
        var addressLngLabel = '';
        var city = '';
        var prov = '';
        var prettyPostal = '';

        if( addressDetails.length ) {
            postal1 = addressDetails[0].attributes.Postal;
            postal2 = addressDetails[0].attributes.PostalExt;
            strName = addressDetails[0].attributes.StName;
            strNumber = addressDetails[0].attributes.AddNum;
            strType = addressDetails[0].attributes.StType;
            strDir = addressDetails[0].attributes.StDir;
            addressLngLabel = addressDetails[0].attributes.Match_addr;
            city = addressDetails[0].attributes.City;
            prov = addressDetails[0].attributes.RegionAbbr;
            prettyPostal = postal1 + " " + postal2;

            strType = strType.replace(/\s/g, '');
            strDir = strDir.replace(/\s/g, '');
        }

        if( strType == "" ) {
            strType = "NA";
        }

        axios
        .get(headerVars.startAPIAddress+"/address/qualify/product?PostalCode="+postal1+postal2+"&StreetName="+strName+"&StreetNumber="+strNumber+"&StreetType="+strType+"&UnitNumber="+qualificationAddressUnit+"&StreetDirection="+strDir, {headers:{"Authorization": "Bearer "+headerVars.startAPIKey}})
        .then(function(response){
            setAddressQualifying( false );
            let qualificationObject = response.data;

            var isD2C = localStorage.getItem('is-d2c-session');

            var productAry = [];

            const id = 'react-qualification-form-container';
            const yOffset = -130; 
            const element = document.getElementById(id);
            const y = element.getBoundingClientRect().top + window.scrollY + yOffset;

            window.scrollTo({top: y, behavior: 'smooth'});

            if( response.data.body.Products ) {
                for( var i=0; i < response.data.body.Products.length; i++ ) {
                    if( response.data.body.Products[i].Service == "Fibre" ) {
                        productAry.push({
                            "service": {
                                "speed": "",
                                "service_id": response.data.body.Products[i].SKU,
                                "action": response.data.body.Products[i].Action,
                                "provider": response.data.body.Products[i].Service,
                                "self_install": response.data.body.Products[i].SelfInstall,
                            }
                        }); 
                    }
                }
            }

            var rogersPortalActive = null;
            if( response.data.body.RogersActive ) {
                rogersPortalActive = response.data.body.RogersActive;
            }

            var altimaPortalActive = null;
            if( response.data.body.AltimaActive ) {
                altimaPortalActive = response.data.body.AltimaActive;
            }

            var unitNumberStr = "";

            if( qualificationAddressUnit != "" ) {
                unitNumberStr = " Unit "+ qualificationAddressUnit;
            }

            var serviceObj = {
                "address": { 
                    "street_number": strNumber,
                    "street_name": strName,
                    "street_type": strType,
                    "street_dir": strDir,
                    "address_string": addressLngLabel + unitNumberStr,
                    "postal": postal1+postal2,
                    "city": city,
                    "province": prov,
                    "unit": qualificationAddressUnit,
                    "latitude": "",
                    "longitude": "",
                },
                "services":productAry,
                "is_d2c":isD2C,
                "rogers_portal_active":rogersPortalActive,
                "altima_portal_active":altimaPortalActive
            };

            handleHubspotSubmission( addressLngLabel, qualificationAddressUnit, prettyPostal, strName, city, strNumber, strType, strDir, prov);

            var qualifiedAddressDataObj = serviceObj;
            var qualifiedAddressDataObjJSON = JSON.stringify(serviceObj);
            var availableServices = qualifiedAddressDataObj.services;

            //console.log('availableServices:: ', availableServices);
            //console.log('qualifiedAddressDataObjJSON:: ', qualifiedAddressDataObjJSON);
            
            if( availableServices.length && availableServices[ 0 ].service.provider == 'Fibre') {
                //console.log("modalOpen::", modalOpen);
                jQuery("#qualificationData").val(qualifiedAddressDataObjJSON);
                document.cookie = 'qualification-data='+qualifiedAddressDataObjJSON;
                //console.log( 'document.cookie::: '+document.cookie );
                removeInternetHardwareFromCart();
                if( modalOpen ){
                    //window.location.href= "/services/high-speed-internet#internet-packages-content-section";
                    handleModalCancel();
                }
                document.dispatchEvent(new CustomEvent('cartInternetProductsUpdateState', { detail: '' }));
            } else {
                jQuery("#qualificationData").val('');
                document.cookie = 'qualification-data=; Max-Age=-99999999;'; 
                document.dispatchEvent(new CustomEvent('cartInternetProductsUpdateState', { detail: '' }));

                if( !isFibreComponent ) {
                    setCountdownTimer(
                        <CountdownTimer 
                            timeInSeconds={ 5 } 
                            handleTimerComplete={ handleTimerComplete }
                            serviceObj={ serviceObj }
                            initialRemainingTime={15}
                        />
                    );

                    if( standalonePhonePurchaseAttempt ) {
                        setQualificationHeader(<h2 style={{ paddingTop:'0', fontSize:'2rem' }} >Sorry, Start Home Phone is not available in your area.<br/><span style={{ fontSize:'1.4rem' }}>Redirecting you to Koodo Internet for your service results in 10 seconds.</span></h2>);
                    } else if( standaloneTVPurchaseAttempt ){
                        setQualificationHeader(<h2 style={{ paddingTop:'0', fontSize:'2rem' }} >Sorry, Start TV is not available in your area.<br/><span style={{ fontSize:'1.4rem' }}>Redirecting you to Koodo Internet for your service results in 10 seconds.</span></h2>);
                    } else {
                        setQualificationHeader(<h2 style={{ paddingTop:'0' }} >Redirecting you to Koodo Internet for your service results in 10 seconds.</h2>);
                    }

                    setShowQualificationForm( false );
                    setQualificationCopy(
                        <>
                            <p>Start.ca and Koodo are now one — enjoy expanded service offerings and support.</p>
                            <Button 
                                type="primary"
                                className="standalone-address-qualifier-btn goto-koodo-btn"
                                loading={ koodoRedirectLoading }
                                style={ 
                                    { 
                                        backgroundColor:'#1C4A12', 
                                        paddingTop:'2px', 
                                        paddingBottom:'2px', 
                                        marginBottom:'0.25rem', 
                                        paddingRight:'2rem',
                                        paddingLeft:'2rem',
                                        fontWeight:'600'
                                    }
                                }
                                onClick={ (e) => handleRedirectToKoodo( e, serviceObj ) }>
                                Continue To Koodo
                            </Button>
                            <Button 
                                //type="primary"
                                className="no-koodo-redirect"
                                //loading={ addressesQualifying }
                                style={ 
                                    { 
                                        backgroundColor:'#fff', 
                                        paddingTop:'2px', 
                                        paddingBottom:'2px', 
                                        marginBottom:'0.25rem',
                                        paddingRight:'2rem',
                                        paddingLeft:'2rem',
                                        marginLeft:'0.5rem',
                                        fontWeight:'600'
                                    }
                                }
                                onClick={ handleDontRedirect }>
                                Stay On This Page
                            </Button>
                            <p style={{fontSize:'0.8rem', marginTop:'1rem'}}>Want to know about the benefits of Start.ca’s partnership with Koodo? <a className='koodo-redirect-modal-learn-more-link' href="/about-us/telus-partnership">Learn more</a>.</p>
                        </>
                    );
                } else {
                    setQualificationHeader(<h2>Check availability of Fibre Internet plans</h2>);
                    setQualificationCopy(  <p>Enter your address to find out what’s available in your area.</p> );
                }
            }
        })
        .catch(function (error) {
            console.log(error);
            setAddressQualifying( false );
        })
        .finally(function () {
            // always executed  
        }); 
    }

    function handleHubspotSubmission( address, unit, postal, strName, city, strNumber, strType, strDir, prov ) {
        var timestamp = Date.now();
        var formID = '7b77f67f-44eb-43a8-b941-d18df2a1ed12';
        var data = {
            "submittedAt": timestamp,
            "fields": [
                {
                    "objectTypeId": "0-1",
                    "name": "address",
                    "value": address
                },
                {
                    "objectTypeId": "0-1",
                    "name": "unit",
                    "value": unit
                },
                {
                    "objectTypeId": "0-1",
                    "name": "postal",
                    "value": postal
                },
                {
                    "objectTypeId": "0-1",
                    "name": "street_name",
                    "value": strName
                },
                {
                    "objectTypeId": "0-1",
                    "name": "city",
                    "value": city
                },
                {
                    "objectTypeId": "0-1",
                    "name": "street_number",
                    "value": strNumber
                },
                {
                    "objectTypeId": "0-1",
                    "name": "street_type",
                    "value": strType
                },
                {
                    "objectTypeId": "0-1",
                    "name": "street_direction",
                    "value": strDir
                },
                {
                    "objectTypeId": "0-1",
                    "name": "province",
                    "value": prov
                }
            ],
            "context": {
                "hutk": hutk,
                "pageUri": "www.start.ca/",
                "pageName": "Start.ca"
            },
        }
        var hutk = document.cookie.replace(/(?:(?:^|.*;\s*)hubspotutk\s*\=\s*([^;]*).*$)|^.*$/, "$1");

        var form_data = JSON.stringify(data);
        var finalData = {
            "formData" : form_data,
            "formID" : formID
        };

        var path = headerVars.themeURI+"/inc/hubspot-tracking.php";

        jQuery.post(path, finalData)
        .done(function( hubspotPushSuccess ) {
            console.log("hubspotPushSuccess: ", hubspotPushSuccess);
        })
        .fail(function() {
            console.log("Hubspot data push failed");
        });
    }

    const handleTimerComplete = ( serviceObj ) => {
        setCountdownTimer(<></>);
        if( !cancelRedirect ) {
            window.location.href = 'https://www.koodomobile.com/on/shop/subscriptions/internet?cmp=prt_kd_sod_tar_ah_starttoki&lpdsid='+magicKey; 
        }
    }

    const removeInternetHardwareFromCart = ( ) => {
        let form_data = new FormData;
        form_data.append('action', 'remove_internet_hardware_after_qualification');
        let requestUrl = {ajax_url : siteDomain+"/wp-admin/admin-ajax.php"};

        axios
        .post(requestUrl.ajax_url, form_data)
        .then(function( response ){
            //let response = response.data;
            //console.log( "response: ", response );
            jQuery( '.header-cart-icon' ).html('');
        })
        .catch(function (error) {
            console.log(error);
        })
        .finally(function () {
            // always executed 
        });
    }

    return (
        <div style={{ marginTop:( isFibreComponent )? '3rem' : '3rem' }} className="startca-react-qualification-form-container" id="react-qualification-form-container">
            <div className='koodo-redirect-timer'>
                { countdownTimer }
            </div>
            { qualificationHeader }
            { qualificationCopy }
            <div 
                className="qualification-form" 
                style={{display:( showQualificationForm ) ? "block" : "none"}}
            >
                <Form
                    form={ form }
                >
                    <div className="form-column-row-inline">
                        <Form.Item
                            label=""
                            name="qualification-address"
                            style={{ marginBottom:'0' }}
                        >
                            <Input
                                id="qualification-address-input"
                                name="qualification-address-input"
                                onChange={handleOnInputChange}
                                ref={ addressInput }
                                placeholder="Enter your street address"
                            />
                        </Form.Item>

                        <Form.Item
                            label=""
                            //labelCol={{ span: 24 }}
                            name="qualification-address-unit-input"
                            style={{ marginBottom:'0' }}
                        >
                            <Input
                                id="qualification-address-unit-input"
                                name="qualification-address-unit-input"
                                onChange={handleOnAddressUnitChange}
                                placeholder="Unit"
                            />
                        </Form.Item>
                        <div className="check-availability-inline">
                            <Form.Item
                                label=""
                                //labelCol={{ span: 24 }}
                                name="qualification-address-apply-button"
                                style={{ marginBottom:'0'}}
                            >
                                <Button 
                                    type="primary"
                                    className="standalone-address-qualifier-btn"
                                    loading={ addressesQualifying }
                                    disabled={ qualificationAddress ? false : true }
                                    id="check-availability-button"
                                    style={ { paddingTop:'2px', paddingBottom:'2px', marginBottom:'0px' } }
                                    onClick={ handleConfirmChangeQualificationAddress }>
                                    Check Availability
                                </Button>
                            </Form.Item>
                        </div>
                    </div>
                    <div className="suggestion-list-container">
                        { addressSuggestionList }
                    </div>
                </Form>
            </div>
        </div>
    )
}

export default QualificationForm